import { createContext } from 'react';

import {
  OrganizationDetails,
  OrganizationHierarchy,
} from '@totem/types/organization';

interface Context {
  loading: boolean;
  orgDetails: OrganizationDetails;
  data: OrganizationHierarchy;
  regions: OrganizationHierarchy[];
  buildings: OrganizationHierarchy[];
  controlSystems: OrganizationHierarchy[];
  selectedRegion: OrganizationHierarchy;
  selectedBuilding: OrganizationHierarchy;
  selectedControlSystem: OrganizationHierarchy;
  setSelectedRegion: (region: OrganizationHierarchy) => void;
  setSelectedBuilding: (building: OrganizationHierarchy) => void;
  setSelectedControlSystem: (controlSystem: OrganizationHierarchy) => void;
  findObject: (objectType: string, objectId: string) => OrganizationHierarchy;
  doRefresh: () => void;
}

export default createContext<Context>({
  loading: false,
  orgDetails: null,
  data: null,
  regions: [],
  buildings: [],
  controlSystems: [],
  selectedRegion: null,
  selectedBuilding: null,
  selectedControlSystem: null,
  setSelectedRegion: () => {},
  setSelectedBuilding: () => {},
  setSelectedControlSystem: () => {},
  findObject: () => {
    return null;
  },
  doRefresh: () => {},
});
